/**
 * Tauri event listeners for the online (mic) recording chunk-upload pipeline
 * (APP-6508). Mirrors `src/tauri/chronicle/events.ts`.
 *
 * Event names must stay in sync with `events` in
 * `src-tauri/src/session/online_chunk_upload.rs`.
 */
import { isTauri } from '@/tauri/utils';
import { type EventCallback, listen } from '@tauri-apps/api/event';

export const ONLINE_CHUNK_UPLOAD_EVENTS = {
  CHUNK_UPLOADED: 'online_chunk:chunk_uploaded',
  CHUNK_FAILED: 'online_chunk:chunk_failed',
  TOKEN_REFRESH_NEEDED: 'online_chunk:token_refresh_needed',
  STREAM_FINISHED: 'online_chunk:stream_finished',
} as const;

export interface OnlineChunkUploadedEvent {
  index: number;
  sizeBytes: number;
  durationMs: number;
}

export interface OnlineChunkFailedEvent {
  index: number;
  errorCode?: string;
  message: string;
}

export async function listenOnlineChunkUploaded(
  cb: EventCallback<OnlineChunkUploadedEvent>
) {
  if (!isTauri()) return () => {};
  return listen<OnlineChunkUploadedEvent>(ONLINE_CHUNK_UPLOAD_EVENTS.CHUNK_UPLOADED, cb);
}

export async function listenOnlineChunkFailed(cb: EventCallback<OnlineChunkFailedEvent>) {
  if (!isTauri()) return () => {};
  return listen<OnlineChunkFailedEvent>(ONLINE_CHUNK_UPLOAD_EVENTS.CHUNK_FAILED, cb);
}

export async function listenOnlineChunkTokenRefreshNeeded(cb: EventCallback<unknown>) {
  if (!isTauri()) return () => {};
  return listen(ONLINE_CHUNK_UPLOAD_EVENTS.TOKEN_REFRESH_NEEDED, cb);
}
